import Tyra from '../pages/tyra/Tyra';
import Send from '../pages/send/Send';
import MarketStory from '../pages/marketStory/MarketStory';
import Expense from '../pages/expense/Expense';
import Panel from '../pages/panel/Panel';
import ReportPage from '../pages/reportPage/ReportPage';
import Login from '../pages/accessPages/login/Login';
import UserForm from '../pages/user/UserForm';

export const privatePagesList = {
  send: {
    slug: 'disparos',
    menuName: 'Disparos',
    pageTitle: 'Disparos',
    menuParent: null,
    component: Send,
    formWrapperType: 'SENDS',
  },
  tyra: {
    slug: 'tyra',
    menuName: 'Trya',
    pageTitle: 'Trya',
    menuParent: null,
    component: Tyra,
    formWrapperType: 'TYRA',
  },
  marketStory: {
    slug: 'market-stories',
    menuName: 'MarketStories',
    pageTitle: 'MarketStories',
    menuParent: null,
    component: MarketStory,
    formWrapperType: 'MARKET_STORIES',
  },
  expense: {
    slug: 'despesas',
    menuName: 'Despesas',
    pageTitle: 'Despesas',
    menuParent: null,
    component: Expense,
    formWrapperType: 'EXPENSES',
  },
  panel: {
    slug: 'painel',
    menuName: 'Painel',
    pageTitle: 'Painel',
    menuParent: null,
    component: Panel,
    formWrapperType: 'PANEL',
  },
  report: {
    slug: 'relatorio',
    menuName: 'Relatório',
    pageTitle: 'Relatório',
    menuParent: null,
    component: ReportPage,
  },
  user: {
    slug: 'usuarios',
    menuName: 'Usuários',
    pageTitle: 'Usuários',
    menuParent: null,
    component: UserForm,
  },
}

export const publicPagesList = {

}
